<template>
    <div class="row">
        <div class="col-12 col-lg-8 mx-auto mt-3 mb-5">
            <div class="steps">
                <button class="steps-btn" :class="{
                        'highlighted': true,
                        'enabled': true,
                        'current': current == 'log'
                    }"
                    @click="openLog"
                >
                    <span>{{ $t('common.log') }}</span>
                </button>
                <button class="steps-btn notfirst" :class="{
                        'highlighted': true,
                        'enabled': true,
                        'current': current == 'summary',
                    }"
                    @click="openSummary"
                >
                    <span>{{ $t('sessions.summary') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import LogFeatures from './LogFeatures'

    export default {

        props: {

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            current: {
                type: String,
                default: 'log'
            },
        },

        data() {
            return {
                features: new LogFeatures(this.$router, this.$auth),
            }
        },

        methods: {

            openLog() {
                this.features.openLog(this.registration, this.simulation)
            },
            
            openSummary() {
                this.features.openSummary(this.registration, this.simulation)
            },
        },
    }
</script>

<style lang="css" scoped>

    .steps {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    }

    .steps-btn {
        transition-property: all;
        transition-duration: .15s;
        transition-timing-function: linear;
        transition-delay: 0s;
        position: relative;
        padding-top: 20px;
        color: #dee2e6;
        border: none;
        background-color: transparent;
        outline: none !important;
        cursor: default;
    }

    .steps-btn.enabled {
        cursor: pointer;
    }

    .steps-btn.current {
        cursor: default;
    }

    .steps-btn.highlighted {
        color: #344767;
    }

    .steps-btn.highlighted span, .steps-btn.enabled span {
        color: #8392ab;
    }

    .steps-btn.current span {
        color: #344767;
    }

    .steps-btn:before {
        position: absolute;
        top: 0;
        left: 50%;
        display: block;
        width: 13px;
        height: 13px;
        content: "";
        transform: translateX(-50%);
        transition: all .15s linear 0s, transform .15s cubic-bezier(.05,1.09,.16,1.4) 0s;
        border: 2px solid currentColor;
        border-radius: 50%;
        background-color: #fff;
        box-sizing: border-box;
        z-index: 3;
    }

    .steps-btn.highlighted:before {
        transform: translateX(-50%) scale(1.2);
        background-color: currentColor;
    }

    .steps-btn.current:before {
        background-color: currentColor;
    }

    .steps-btn.notfirst:after {
        position: absolute;
        top: 5px;
        left: calc(-50% - 13px / 2);
        transition-property: all;
        transition-duration: .15s;
        transition-timing-function: linear;
        transition-delay: 0s;
        display: block;
        width: 100%;
        height: 2px;
        content: "";
        background-color: currentColor;
        z-index: 1;
    }

</style>